<template>
  <div class="wemail-site-nav-wrap">
    <router-link tag="a-button" :to="{name:'sites.overview'}" active-class="ant-menu-item-selected" exact>Overview</router-link>
    <router-link tag="a-button" :to="{name:'sites.campaigns'}" active-class="ant-menu-item-selected" exact>Campaigns</router-link>
    <router-link tag="a-button" :to="{name:'sites.lists'}" active-class="ant-menu-item-selected" exact>Lists</router-link>
    <router-link tag="a-button" :to="{name:'sites.logs'}" active-class="ant-menu-item-selected" exact>Events & Logs</router-link>
    <router-link tag="a-button" :to="{name:'sites.health'}" active-class="ant-menu-item-selected" exact>Health</router-link>
    <router-link tag="a-button" :to="{name:'sites.settings'}" active-class="ant-menu-item-selected" exact>Settings</router-link>
    <router-link tag="a-button" :to="{name:'sites.subscription'}" active-class="ant-menu-item-selected" exact>Subscription</router-link>
    <router-link tag="a-button" :to="{name:'sites.team'}" active-class="ant-menu-item-selected" exact>Team</router-link>
  </div>
</template>
<script>
export default {};
</script>

<style>

[ant-click-animating-without-extra-node]:after {
  animation: 0s !important;
}
.wemail-site-nav-wrap {
  display: flex;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d9d9d9;
  padding: 10px 10px 0;
}
.wemail-site-nav-wrap button {
  border-radius: 0;
  border-color: transparent;
  height: auto;
  padding: 12px 25px;
  box-shadow: none;
  margin-right: 5px;
}
.wemail-site-nav-wrap button.ant-menu-item-selected {
  background: #fafafa;
  border-color: #d9d9d9;
  position: relative;
  border-radius: 3px 3px 0 0;
}
.wemail-site-nav-wrap button.ant-menu-item-selected:after {
  content: "";
  position: absolute;
  width: 100%;
  z-index: 99;
  left: 0;
  top: 100%;
  height: 2px;
  background: #fafafa;
}
.wemail-site-nav-wrap button:hover {
  border-color: #d9d9d9;
  border-bottom-color: #1890ff;
}
.wemail-site-nav-wrap button:not(:last-child) {
  /* border-right: 0; */
}
.wemail-site-nav-wrap button:first-child {
  /* border-radius: 3px 0 0 3px; */
}
.wemail-site-nav-wrap button:last-child {
  /* border-radius: 0 3px 3px 0; */
}
</style>


